import type { Commande } from '../../api/types';
import { FLAG_SWITCH } from '../../lib/labels';
import { Card, Switch } from '../ui';

/** Carte « Rechargement de l'app » (interrupteurs setFlags). */
export default function ReglagesCard({
  commande,
  onToggleFlag,
  busy,
}: {
  commande: Commande;
  /** Override manuel via `setFlags`. */
  onToggleFlag: (flag: 'action' | 'actionCodeBarre', value: boolean) => void;
  busy: boolean;
}) {
  return (
    <Card>
      <p className="text-xs font-semibold uppercase tracking-[0.12em] text-outline">Rechargement de l’app</p>
      <div className="mt-2 flex flex-col gap-1">
        <Switch
          label={FLAG_SWITCH.action.label}
          description={FLAG_SWITCH.action.technical}
          showState={false}
          checked={commande.flagAction}
          disabled={busy}
          onChange={(value) => onToggleFlag('action', value)}
        />
        <Switch
          label={FLAG_SWITCH.actionCodeBarre.label}
          description={FLAG_SWITCH.actionCodeBarre.technical}
          showState={false}
          checked={commande.flagActionCodeBarre}
          disabled={busy}
          onChange={(value) => onToggleFlag('actionCodeBarre', value)}
        />
      </div>
      <p className="mt-2 text-xs/4 text-outline">
        L’app se synchronise à l’ouverture, au retour au premier plan et au pull-to-refresh. Une fois la commande
        rechargée, l’interrupteur se désactive tout seul. Les actions ci-dessous l’activent automatiquement quand
        c’est nécessaire ; ici, on peut le forcer ou l’annuler.
      </p>
    </Card>
  );
}
